// @flow
import type {IntlShape} from 'react-intl';

export const cappedTotal = 300;

export const cappedTotalText = '300+';

const resultsCountText = (
    fromRecord: number,
    toRecord: number,
    resultCount: number,
    intl: IntlShape
): string => {
    const cappedTotalKey = 'page.countTotalCapped';
    const id = resultCount <= cappedTotal ? 'page.countTotal' : cappedTotalKey;
    return intl.formatMessage(
        {id, defaultMessage: cappedTotalKey},
        {from: fromRecord, to: toRecord, total: resultCount, cappedTotal}
    );
};

export default resultsCountText;
